import React from "react";
export default function Inventory() {
  return <h2>Inventory Management Coming Soon...</h2>;
}